// Central content + brand config for Faf's by Rivella Enterprise
const WA_BASE = "https://wa.me/233555752746";
const WA_ORDER_MSG = "Hello Faf's by Rivella. I would like to place an order. Please share your available products and pricing.";
const WA_CATERING_MSG = "Hello Faf's by Rivella. I would like information about your catering services.";

export const CONTACT = {
  businessName: "Rivella Enterprise",
  phone: "+233 (0) 24 462 9312",
  phoneHref: "tel:+233244629312",
  phone2: "+233 (0) 26 262 9312",
  phone2Href: "tel:+233262629312",
  whatsapp: "+233 (0) 55 575 2746",
  whatsappHref: WA_BASE,
  whatsappOrderHref: `${WA_BASE}?text=${encodeURIComponent(WA_ORDER_MSG)}`,
  whatsappCateringHref: `${WA_BASE}?text=${encodeURIComponent(WA_CATERING_MSG)}`,
  email: "rivellaenterprise@gmail.com",
  emailHref: "mailto:rivellaenterprise@gmail.com",
  address: "Ngleshi Amanfro, Accra, Ghana",
  hours: [
    { day: "Monday – Friday", time: "9:00 AM – 8:00 PM" },
    { day: "Saturday", time: "7:00 AM – 6:00 PM" },
    { day: "Sunday", time: "1:00 PM – 6:00 PM" },
  ],
  // No social accounts are live yet. Add entries here once they are active.
  socials: [],
};

export const SEO_PAGES = {
  home: {
    title: "Faf's by Rivella | Authentic Ghanaian Flavours",
    description:
      "Authentic Ghanaian drinks, snacks and catering services. FDA-registered products made with locally sourced ingredients and crafted for healthy living.",
  },
  about: {
    title: "About Us | Faf's by Rivella Enterprise",
    description:
      "Meet Rivella Enterprise and our flagship brand Faf's. Our vision, mission and values — promoting wellness through quality, natural, locally sourced Ghanaian products.",
  },
  products: {
    title: "Products | Faf's by Rivella Enterprise",
    description:
      "Explore Faf's fresh juices, smoothies, traditional local drinks, pastries, snacks and spices. FDA-registered, naturally crafted with no added sugar.",
  },
  catering: {
    title: "Catering & Event Drink Bar | Faf's by Rivella",
    description:
      "Book a premium, fully serviced Faf's healthy drink bar for weddings, corporate events, churches and celebrations across Ghana. Custom menus and styled setups.",
  },
  gallery: {
    title: "Gallery | Faf's by Rivella Enterprise",
    description:
      "A look inside the Faf's world — authentic Ghanaian drinks, freshly baked snacks, packaged products and styled event drink bars.",
  },
  contact: {
    title: "Contact Us | Faf's by Rivella Enterprise",
    description:
      "Order or enquire from Faf's by Rivella. Reach us via WhatsApp, phone or email. Based in Ngleshi Amanfro, Accra, Ghana.",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Catering", to: "/catering" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/5945669/pexels-photo-5945669.jpeg",
  heroSecondary: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aboutFounder: "https://images.unsplash.com/photo-1573246123716-6b1782bfc499?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  catering: "/assets/faf-preserved/g20w14g1_Drink_Bar_1.jpeg",
  cateringAlt: "/assets/faf-preserved/16wg848s_Drink_Bar_2.jpeg",
  cateringPour: "/assets/faf-preserved/peibs388_Aliha_1.jpeg",
  founder: "/assets/faf-preserved/e7cunplf_F1.jpeg",
  healthyLiving: "https://images.pexels.com/photos/36765501/pexels-photo-36765501.jpeg",
  family: "https://images.unsplash.com/photo-1627662166825-a860471632e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  familyBreakfast: "https://images.pexels.com/photos/9885075/pexels-photo-9885075.jpeg?auto=compress&cs=tinysrgb&w=1200",
  veggies: "https://images.unsplash.com/photo-1612362426802-dcc0ccd25f64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PRODUCT_CATEGORIES = [
  {
    id: "fresh-juices",
    name: "Fresh Juices",
    tagline: "Cold-pressed, never from concentrate",
    image: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    description:
      "Cold-pressed daily from sun-ripened Ghanaian fruit. No added sugar, no preservatives — just pure, vibrant nutrition in every bottle.",
    items: ["Pineapple & Ginger", "Orange Sunrise", "Watermelon Mint", "Carrot & Citrus"],
  },
  {
    id: "smoothies",
    name: "Smoothies",
    tagline: "Wholesome blends, real fruit",
    image: "https://images.pexels.com/photos/16096610/pexels-photo-16096610.jpeg?auto=compress&cs=tinysrgb&w=1000",
    description:
      "Thick, creamy and nutrient-dense smoothies blended with real fruit, leafy greens and natural goodness — a meal you can drink.",
    items: ["Green Detox", "Berry Boost", "Banana Oat", "Mango Tango"],
  },
  {
    id: "traditional-drinks",
    name: "Traditional Local Drinks",
    tagline: "Heritage flavours, reimagined",
    image: "/assets/faf-preserved/peibs388_Aliha_1.jpeg",
    description:
      "Beloved Ghanaian classics crafted the natural way — Sobolo, Asaana, Lamugin and more, with no artificial colouring.",
    items: ["Sobolo (Hibiscus)", "Asaana", "Lamugin", "Brukina"],
  },
  {
    id: "pastries",
    name: "Pastries & Snacks",
    tagline: "Freshly baked, wholesome",
    image: "/assets/faf-preserved/9qp4p9ah_Chinchin_1.jpeg",
    description:
      "Artisan baked treats made in small batches with quality ingredients — including our signature FDA-registered Faf's Crunchy Chinchin in Coconut and Ginger.",
    items: ["Crunchy Chinchin (Ginger)", "Crunchy Chinchin (Coconut)", "Wholegrain Loaves", "Healthy Muffins"],
  },
  {
    id: "spices",
    name: "Spices & Blends",
    tagline: "Pure, aromatic, natural",
    image: "https://images.pexels.com/photos/32281706/pexels-photo-32281706.jpeg?auto=compress&cs=tinysrgb&w=1000",
    description:
      "Carefully sourced and blended spices that bring authentic West African flavour to your kitchen — clean, potent and natural.",
    items: ["Suya Spice", "Jollof Blend", "Pepper Mix", "Ginger Powder"],
  },
  {
    id: "event-bar",
    name: "Event Drink Bar",
    tagline: "A statement at every gathering",
    image: "/assets/faf-preserved/16wg848s_Drink_Bar_2.jpeg",
    description:
      "A fully styled, on-site healthy drink bar for weddings, corporate functions and celebrations — fresh, premium and unforgettable.",
    items: ["Custom Menus", "Styled Setup", "On-site Service", "Branded Glassware"],
  },
];

export const WHY_CHOOSE = [
  {
    icon: "leaf",
    title: "100% Natural",
    text: "No artificial flavours, colours or preservatives. Only real, recognisable ingredients.",
  },
  {
    icon: "sprout",
    title: "Locally Sourced",
    text: "We partner with Ghanaian farmers for the freshest, most flavourful produce.",
  },
  {
    icon: "heart-pulse",
    title: "Health-First",
    text: "Every recipe is crafted to nourish — low in sugar, high in goodness.",
  },
  {
    icon: "award",
    title: "Premium Quality",
    text: "Certified, consistent and crafted to the highest food-safety standards.",
  },
];

export const POSITIONING = {
  tagline: "Healthy habits start now.",
  vision:
    "To be known for promoting wellness through quality natural products.",
  mission:
    "To build a trusted brand that promotes wellness and great taste while fostering community through quality products and exceptional service.",
};

export const CORE_VALUES = [
  { icon: "award", title: "Quality" },
  { icon: "heart-pulse", title: "Wellness" },
  { icon: "shield-check", title: "Integrity" },
  { icon: "lightbulb", title: "Innovation" },
  { icon: "heart-handshake", title: "Customer Care" },
  { icon: "users", title: "Community" },
];

export const DIFFERENTIATORS = [
  "Custom-made orders to customer specifications",
  "Small-batch production for freshness",
  "Locally sourced ingredients",
  "No artificial additives in local drinks",
  "No added sugar in fruit juices",
  "Naturally sweetened options using pineapple, tigernut and dates",
  "Environmentally conscious operations",
];

export const SUSTAINABILITY = [
  {
    icon: "recycle",
    title: "Plastic to Paper",
    text: "We're transitioning from disposable plastic cups to paper alternatives — reducing single-use plastic across our operations.",
  },
  {
    icon: "flame",
    title: "Firewood to LPG",
    text: "We've moved from firewood to cleaner LPG for production, lowering emissions and our environmental footprint.",
  },
];

export const SOCIAL_IMPACT = [
  { icon: "sprout", title: "Supporting Local Farmers", text: "We source from Ghanaian farmers, strengthening local value chains." },
  { icon: "apple", title: "Healthier Choices", text: "We make wholesome food and drink the easy, everyday option." },
  { icon: "briefcase", title: "Job Creation", text: "Our growth creates meaningful employment in our community." },
  { icon: "package", title: "Local Alternatives", text: "Locally produced options to imported snacks and sugary drinks." },
];

export const SDGS = [
  { number: "3", title: "Good Health & Well-Being" },
  { number: "8", title: "Decent Work & Economic Growth" },
  { number: "12", title: "Responsible Consumption & Production" },
];

export const CERTIFICATIONS = [
  { icon: "badge-check", title: "FDA Approved", text: "Registered & approved by Ghana's Food and Drugs Authority." },
  { icon: "shield-check", title: "GSA Certified", text: "Compliant with Ghana Standards Authority quality marks." },
  { icon: "leaf", title: "HACCP Aligned", text: "Hygiene and safety controls across every production step." },
  { icon: "sparkles", title: "Hand-Crafted", text: "Made fresh daily in small, carefully monitored batches." },
];

export const FOUNDER = {
  name: "Fafa Amable",
  role: "Founder & CEO, Rivella Enterprise",
  image: IMAGES.founder,
  bio: [
    "Faf's was born from Fafa Amable's lifelong belief that healthy, authentic Ghanaian food should be accessible, beautifully made and something to be proud of.",
    "A certified food processing professional trained by the CSIR Food Research Institute, Fafa blends traditional Ghanaian recipes with modern food-safety standards — turning a home kitchen passion into a trusted, FDA-registered brand.",
  ],
  highlights: [
    "CSIR-trained food processing professional",
    "Champion of locally sourced, natural ingredients",
    "Building a brand families across Ghana can trust",
  ],
};

export const CERTIFICATES = [
  {
    title: "FDA Registered Product",
    issuer: "Food and Drugs Authority, Ghana",
    text: "Our products are officially registered and approved for sale under Ghana's Public Health Act.",
    image: "/assets/faf-preserved/5eman864_FDA_1.jpg",
  },
  {
    title: "Registered Business",
    issuer: "Registrar General's Department",
    text: "Rivella Enterprise is a fully registered business operating in the Republic of Ghana.",
    image: "/assets/faf-preserved/sx56xkby_REGISTRATION_CERT_1.jpg",
  },
  {
    title: "Environmental Health Certification",
    issuer: "Ayawaso West Municipal Assembly",
    text: "Certified for safe food handling, processing and sanitation standards.",
    image: "/assets/faf-preserved/h3h7s5e2_AYAWASO_ASSEMBLY_1.jpg",
  },
  {
    title: "CSIR Food Processing Training",
    issuer: "CSIR – Food Research Institute",
    text: "Professionally trained in modern food processing techniques and best practices.",
    image: "/assets/faf-preserved/2jsgpd0i_CSIR_1.jpg",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Faf's catered our corporate wellness day and the drink bar was the talk of the office. Premium, fresh and beautifully presented.",
    name: "Ama Boateng",
    role: "HR Lead, Accra",
  },
  {
    quote:
      "We serve Faf's juices at our hotel breakfast and guests constantly ask where they're from. The quality is unmatched.",
    name: "Daniel Mensah",
    role: "Hotel Manager",
  },
  {
    quote:
      "As a mum, I love that I can trust what my kids are drinking. Natural, no nonsense, and they actually love the taste.",
    name: "Efua Asante",
    role: "Parent & Loyal Customer",
  },
  {
    quote:
      "Their event drink bar made our wedding feel so special and healthy. Professional team, gorgeous setup.",
    name: "Kwabena Osei",
    role: "Event Planner",
  },
];

export const AUDIENCES = [
  "Families",
  "Corporate Organisations",
  "Churches",
  "Schools",
  "Hotels",
  "Event Planners",
  "Health-Conscious Consumers",
];

export const GALLERY = [
  { url: "/assets/faf-preserved/9qp4p9ah_Chinchin_1.jpeg", alt: "Faf's Crunchy Chinchin packaged range", span: "tall" },
  { url: "https://images.pexels.com/photos/16096610/pexels-photo-16096610.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Colourful smoothies", span: "wide" },
  { url: "/assets/faf-preserved/g20w14g1_Drink_Bar_1.jpeg", alt: "Faf's event catering setup", span: "normal" },
  { url: "/assets/faf-preserved/csxga7cx_Chinchin_3.jpeg", alt: "Bowl of freshly baked Crunchy Chinchin", span: "normal" },
  { url: "https://images.pexels.com/photos/32281706/pexels-photo-32281706.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Spice blends", span: "tall" },
  { url: "/assets/faf-preserved/peibs388_Aliha_1.jpeg", alt: "Traditional local drink served over ice", span: "normal" },
  { url: "/assets/faf-preserved/16wg848s_Drink_Bar_2.jpeg", alt: "Faf's snack & drink bar at an event", span: "wide" },
  { url: "https://images.unsplash.com/photo-1610970881699-44a5587cabec?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Green smoothie", span: "normal" },
  { url: "https://images.pexels.com/photos/29851973/pexels-photo-29851973.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Assorted bottled juices", span: "normal" },
  { url: "https://images.unsplash.com/photo-1627662166825-a860471632e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Family enjoying healthy food", span: "tall" },
  { url: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Fresh juices in glasses", span: "normal" },
  { url: "https://images.unsplash.com/photo-1532336414038-cf19250c5757?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Bowls of spices", span: "normal" },
];

export const ARTICLES = [
  {
    title: "5 Reasons to Start Your Morning with Cold-Pressed Juice",
    category: "Nutrition",
    excerpt:
      "Discover how a single glass of cold-pressed juice can flood your body with vitamins, hydrate your cells and energise your day naturally.",
    image: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    read: "4 min read",
  },
  {
    title: "The Hidden Power of Sobolo (Hibiscus)",
    category: "Heritage",
    excerpt:
      "This beloved Ghanaian drink is more than refreshing — it's rich in antioxidants and a proud part of our wellness story.",
    image: "https://images.unsplash.com/photo-1622597467836-f3285f2131b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    read: "5 min read",
  },
  {
    title: "Healthy Eating for Busy Families",
    category: "Lifestyle",
    excerpt:
      "Simple, realistic swaps to keep your whole family nourished — without spending hours in the kitchen.",
    image: "https://images.pexels.com/photos/9885075/pexels-photo-9885075.jpeg?auto=compress&cs=tinysrgb&w=900",
    read: "6 min read",
  },
  {
    title: "What 'No Added Sugar' Really Means",
    category: "Wellness",
    excerpt:
      "We break down the label so you can make confident, informed choices for you and the people you love.",
    image: "https://images.unsplash.com/photo-1612362426802-dcc0ccd25f64?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    read: "3 min read",
  },
];

export const TIPS = [
  { icon: "droplets", title: "Hydrate First", text: "Begin each day with water or a fresh juice to wake up your system." },
  { icon: "apple", title: "Eat the Rainbow", text: "Vary your fruit and veg colours for a fuller spectrum of nutrients." },
  { icon: "moon", title: "Rest Well", text: "Quality sleep is the foundation of every healthy lifestyle." },
  { icon: "activity", title: "Move Daily", text: "A short walk after meals supports digestion and energy." },
];
